import React, { useState, FormEvent } from 'react';

import PageHeader from '../../components/PageHeader';
import Input from '../../components/Imput';
import Textarea from '../../components/Textarea';
import Select from '../../components/Select';

import warningIcon from '../../assets/images/icons/warning.svg';

import './styles.css';

function TeacherForm() {

    const [name, setName] = useState('')
    const [avatar, setAvatar] = useState('')
    const [whatsapp, setWhatsapp] = useState('')
    const [bio, setBio] = useState('')

    const [subject, setSubject] = useState('')
    const [cost, setCost] = useState('')

    const [scheduleItems, setScheduleItems] = useState([
        { week_day: 0, from: '', to: '' }
    ])

    function addNewScheduleItem() {
        setScheduleItems([
            ...scheduleItems,
            { week_day: 0, from: '', to: '' }
        ])
    }

    function setScheduleItemValue(pos: number, field: string, value: string) {
        const newArray = scheduleItems.map((scheduleItem, index) => {
            if (index === pos) {
                return { ...scheduleItem, [field]: value }
            }

            return scheduleItem
        })
        setScheduleItems(newArray)
    }

    function createClass(event: FormEvent) {
        event.preventDefault()
        alert('É apenas uma demostração, os dados não serão enviados para nenhum lugar!')

        // api.post('classes', {
        //     name, 
        //     avatar, 
        //     whatsapp, 
        //     bio, 
        //     subject, 
        //     cost: Number(cost),
        //     schedule: scheduleItems
        // })
        // .then(() => {
        //     alert('Cadastro Realizado')
        //     history.push('/')
        // })
        // .catch(() => alert('Erro no Cadastro'))
    }


    return (
        <div id="page-teacher-form" className="container">
            <PageHeader
                title="Que incrível que você quer dar aulas."
                description="O primeiro passo é preencher esse formulário de inscrição"
            />

            <main>
                <form onSubmit={createClass}>
                    <fieldset>
                        <legend>Seus dados</legend>

                        <Input
                            name="name"
                            label="Nome completo"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                        <Input
                            name="avatar"
                            label="Avatar"
                            value={avatar}
                            onChange={e => setAvatar(e.target.value)}
                        />
                        <Input
                            name="whatsapp"
                            label="Whatsapp"
                            value={whatsapp}
                            onChange={e => setWhatsapp(e.target.value)}
                        />
                        <Textarea
                            name="bio"
                            label="Biografia"
                            value={bio}
                            onChange={e => setBio(e.target.value)}
                        />
                    </fieldset>

                    <fieldset>
                        <legend>Sobre a aula</legend>

                        <Select
                            name="subject"
                            label="Matéria"
                            value={subject}
                            onChange={e => setSubject(e.target.value)}
                            options={[
                                { id: 'web_fullstack', label: 'Desenvolvimento Web Fullstack' },
                                { id: 'ai_llms', label: 'Inteligência Artificial & LLMs' },
                                { id: 'js_logic', label: 'Lógica de Programação com JavaScript' },
                                { id: 'mobile_react', label: 'Desenvolvimento Mobile (React Native)' },
                                { id: 'prompt_engineering', label: 'Engenharia de Prompt' },
                                { id: 'data_structures', label: 'Estrutura de Dados e Algoritmos' },
                            ]}
                        />
                        <Input
                            name="cost"
                            label="Custo da sua hora por aula"
                            value={cost}
                            onChange={e => setCost(e.target.value)}
                        />
                    </fieldset>

                    <fieldset>
                        <legend>
                            Horários disponíveis
                            <button type="button" onClick={addNewScheduleItem}>
                                + Novo horário
                            </button>
                        </legend>

                        {scheduleItems.map((item, index) => {
                            return (
                                <div key={item.week_day} className="schedule-item">
                                    <Select
                                        name="week-day"
                                        label="Dia da semana"
                                        value={item.week_day}
                                        onChange={e => setScheduleItemValue(index, 'week_day', e.target.value)}
                                        options={[
                                            { id: '0', label: 'Domingo' },
                                            { id: '1', label: 'Segunda-feira' },
                                            { id: '2', label: 'Terça-feira' },
                                            { id: '3', label: 'Quarta-feira' },
                                            { id: '4', label: 'Quinta-feira' },
                                            { id: '5', label: 'Sexta-feira' },
                                            { id: '6', label: 'Sábado' },
                                        ]}
                                    />
                                    <Input
                                        name="from"
                                        label="Das"
                                        type="time"
                                        value={item.from}
                                        onChange={e => setScheduleItemValue(index, 'from', e.target.value)}
                                    />
                                    <Input
                                        name="to"
                                        label="Até"
                                        type="time"
                                        value={item.to}
                                        onChange={e => setScheduleItemValue(index, 'to', e.target.value)}
                                    />
                                </div>
                            )
                        })}
                    </fieldset>

                    <footer>
                        <p>
                            <img src={warningIcon} alt="Aviso importante" />
                            Importante <br />
                            Preencha todos os dados
                        </p>
                        <button type="submit"> Salvar cadastro</button>
                    </footer>
                </form>
            </main>
        </div>
    )
}

export default TeacherForm;